import { render, staticRenderFns } from "./OrderGvcList.vue?vue&type=template&id=4c1fb890&scoped=true&"
import script from "./OrderGvcList.vue?vue&type=script&lang=js&"
export * from "./OrderGvcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1fb890",
  null
  
)

export default component.exports